/** @format */

import axiosConfig from "../configs/axiosConfig";

export const uploadFile = async (formData) => {
  try {
    const response = await axiosConfig({
      method: "POST",
      url: "/public/upload.php",
      data: formData,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return "Fail";
  }
};

export const getblogs = async (page, pageSize) => {
  try {
    const response = await axiosConfig({
      method: "GET",
      url: "/blog/get_all.php",
      params: {
        page: page,
        pageSize: pageSize,
      },
    });

    return response.data;
  } catch (error) {
    console.log(error);
    return "Fail";
  }
};
export const getblogbyid = async (id) => {
  try {
    const response = await axiosConfig({
      method: "GET",
      url: `/blog/get_by_id.php`,
      params: {
        id: id,
      },
    });

    return response;
  } catch (error) {
    console.error(error.message);
  }
};

export const deleteblogbyid = async (id) => {
  try {
    const response = await axiosConfig({
      method: "DELETE",
      url: `/blog/delete.php`,
      data: {
        id: id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return "Fail";
  }
};

export const apiCreateBlogs = async (payload) => {
  // try {
  //   const response = await axiosConfig({
  //     method: "POST",
  //     url: "/blog",
  //     data: payload,
  //   });

  //   return response;
  // } catch (error) {
  //   console.error(error.message);
  // }
  const response = await axiosConfig({
    method: "POST",
    url: "/blog/create.php",
    data: payload,
    transformRequest: [
      (data) => {
        return JSON.stringify(data);
      },
    ],
  });

  return response;
};

export const apiUpdateBlogByID = async (payload) => {
  // try {
  //   const response = await axiosConfig({
  //     method: "POST",
  //     url: "/blog",
  //     data: payload,
  //   });

  //   return response;
  // } catch (error) {
  //   console.error(error.message);
  // }
  const response = await axiosConfig({
    method: "PUT",
    url: `/blog/update.php`,
    data: payload,
  });

  return response;
};
